import React from 'react';
import { ListGroupItem } from "react-bootstrap";


const AddNew = (props) => {
  return (
    <div>
      <ListGroupItem
        href={props.href}
        onClick={props.click}
      >
        <h4>
          <b>{"\uFF0B"}</b> {props.name}
        </h4>
      </ListGroupItem>
    </div>
  )
}

export default AddNew;


// WEBPACK FOOTER //
// ./src/components/AddNew.js